import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
 
const firebaseConfig = {
  apiKey: "AIzaSyA4qnbyUP0phCMRFNJE8qq-KGoCPu75GFE",
  authDomain: "zoomlogi-sign-up.firebaseapp.com",
  databaseURL: "https://zoomlogi-sign-up-default-rtdb.firebaseio.com",
  projectId: "zoomlogi-sign-up",
  storageBucket: "zoomlogi-sign-up.firebasestorage.app",
  messagingSenderId: "886121035549",
  appId: "1:886121035549:web:1a3d844487eeffc4dc53f4",
  measurementId: "G-PX3275RWK3"
};
 
const app = initializeApp(firebaseConfig);
 
const db = getDatabase(app);
 
export { db };